
import '@/assets/scss/index.scss'
import TitleCmp from '@/components/mb/TitleCmp.vue'
import { commonfunc } from '~/mixin/common'
export default {
  name: 'Main',
  components: {
    TitleCmp
  },
  mixins: [commonfunc],
  layout: 'DsMainLayout',
  middleware: 'noSessionRoute',
  data () {
    return {
      titleData: {
        title: '다이소',
        crumbs: []
      },
      joinEasyBtn: [ // 간편 가입 버튼 리스트
        {
          icon: 'kakao',
          label: '카카오톡 간편 가입',
          snsTy: 'A'
        },
        /*
        {
          icon: 'naver',
          label: '네이버 간편 가입',
          snsTy: 'B'
        },
        {
          icon: 'google',
          label: '구글 간편 가입',
          snsTy: 'C'
        },
        */
        {
          icon: 'apple',
          label: '애플 간편 가입',
          snsTy: 'D'
        }
      ],
      baseUrl: '',
      snsForm: {
        snsTy: '',
        snsInrkCtky: '',
        encId: '',
      }
    }
  },
  head () {
    return {
      title: '회원가입 안내 : 다이소몰',
      meta: [
        { hid: 'og:title', property: 'og:title', content: '회원가입 안내 : 다이소몰' },
        { hid: 'og:url', property: 'og:url', content: window.location.href }]
    }
  },
  async mounted () {
    // 파라미터 숨기기
    window.history.replaceState(null, null, this.$route.path)

    window.addEventListener('load', () => {
      window.addEventListener('scroll', () => {
        this.scrollY = Math.round(window.scrollY)
      })
    })

    const tiles = document.querySelectorAll('.logo-daiso.login-title')
    tiles.forEach(tile => tile.addEventListener('click', this.handleTileClick))

    this.baseUrl = process.env.API_BASE_URL

    if (this.isNotEmpty(this.$route.query.snsTy)) { // sns연동 후 redirect 접근
      await this.snsCallback()
    }
  },
  methods: {
    handleTileClick () {
      this.$router.push('/ds')
    },
    snsMbSbsc (type) {
      let url = ''
      switch (type) {
        case 'A':{
          url = 'https://kauth.kakao.com/oauth/authorize?client_id=' + process.env.KAKAO_CLIENT_ID +
          '&redirect_uri=' + this.baseUrl + process.env.KAKAO_JOIN_REDIRECT_URI + '&response_type=code'
          window.location.replace(url)
          break
        }
        case 'B':{
          url = 'https://nid.naver.com/oauth2.0/authorize?response_type=code&client_id=' + process.env.NAVER_CLIENT_ID +
          '&redirect_uri=' + this.baseUrl + process.env.NAVER_JOIN_REDIRECT_URI
          window.location.replace(url)
          break
        }
        // case 'C':{
        //   url = 'https://accounts.google.com/o/oauth2/v2/auth?client_id=' +
        //   process.env.GOOGLE_CLIENT_ID +
        //   '&redirect_uri=' +
        //   this.baseUrl + process.env.GOOGLE_JOIN_REDIRECT_URI +
        //   '&response_type=code' +
        //   '&scope=email profile'
        //   window.location.replace(url)
        //   break
        // }
        case 'D':{
          const clientId = process.env.APPLE_CLIENT_ID // Service IDs 생성할 때 등록한 identifer
          const redirectUri = this.baseUrl + process.env.APPLE_JOIN_REDIRECT_URI // Service IDs 생성할 때 등록한 Return URLs
          // response_type (required) → 응답 유형을 선택, "code" or "code id_token"
          // response_mode (required) → 응답 모드를 선택, "query" or "fragment" or "form_post"
          // scope → 로그인을 통해 확인하고 싶은 정보를 선택, "email" or "name" or "email name" (scope를 사용할 경우 response_mode는 form_post가 필수)
          location.href = 'https://appleid.apple.com/auth/authorize?response_type=code&response_mode=form_post&scope=email&client_id=' + clientId +
          '&redirect_uri=' + redirectUri
          break
        }
      }
    },
    goMain () {
      this.$router.push('/ds')
    },
    async snsCallback () {
      const snsInrkCtky = this.$route.query.snsInrkCtky
      const encId = decodeURIComponent(this.$route.query.encId)
      await this.$AxiosBuilder
        .data({ snsInrkCtky, encId, page: 'join' })
        .build()
        .post('/mb/mbc/getSnsInfo')
        .then((res) => {
          if (res.data.success) {
            if (res.data.data === 'JOIN_PASS') {
              this.snsForm.snsTy = res.data.extraData.snsTy
              this.snsForm.snsInrkCtky = snsInrkCtky
              this.snsForm.encId = encId
              if (this.isNotEmpty(this.snsForm.snsTy) && this.isNotEmpty(this.snsForm.snsInrkCtky)) {
                this.$store.commit('session/setJoinData', JSON.stringify(this.snsForm))
              } else {
                this.$alert('오류가 발생했습니다. 관리자에게 문의해주십시요.').then(() => {
                  this.$router.push('/mb/mbb/SCR_MBB_0097A')
                })
              }
              this.$router.push({
                name: 'mb-mba-SCR_MBA_0086C',
                path: '/mb/mba/SCR_MBA_0086C'
              })
            }
          } else if (res.data.returnCode === 'INVALID') {
            this.$alert(res.data.message)
          } else {
            const failCause = res.data.data
            console.log(failCause)
            if (failCause === 'ALREADY_LINKED') {
              this.$alert('이미 등록된 SNS 계정입니다. SNS 로그인을 이용해주세요.', '', {
                confirmButtonText: '확인',
                dangerouslyUseHTMLString: true
              }).then(() => {
                this.$router.push({
                  name: 'mb-mbb-SCR_MBB_0097A',
                  path: '/mb/mbb/SCR_MBB_0097A'
                })
              }).catch(() => {})
            }
          }
        })
        .catch((err) => {
          console.log('error')
          console.log(err)
        })
    }
  }
}
